import React from "react"
import { useOutletContext } from "react-router-dom"

import Table from "@components/Table"
import { VIRTUAL_TABLE_HEIGHT } from "@components"

const SUMMARY_HEIGHT = 40
const PAGINATION_HEIGHT = 56
const HEADER_FILTERS_HEIGHT = 32


const VirtualTable = ({
  ...tableProps
}) => {
  const { layoutTopOffset = 0 } = useOutletContext()
  const { extraTopOffset = 0 } = tableProps

  const hasSummary = !!tableProps.summary
  const hasPagination = !!tableProps.pagination
  const hasHeaderFilters = tableProps.hasHeaderFilters || tableProps.hasHeaderSegment

  const yScroll = VIRTUAL_TABLE_HEIGHT
    - (hasSummary ? SUMMARY_HEIGHT : 0)
    - (hasPagination ? PAGINATION_HEIGHT : 0)
    - (hasHeaderFilters ? HEADER_FILTERS_HEIGHT : 0)
    - layoutTopOffset
    - extraTopOffset

  const scroll = {
    y: yScroll,
    x: "max-content"
  }

  // rc-table's sticky scroll bar assumes scroll body ref is a DOM node and calls
  // getBoundingClientRect(); with virtual scroll the ref can be non-DOM → TypeError.
  // Disable sticky when using virtual scroll to avoid BACKSTAGE-6E / #2696.
  const { sticky: _sticky, ...restTableProps } = tableProps

  return (
    <Table
      virtual
      scroll={scroll}
      {...restTableProps}
    />
  )
}

export default VirtualTable
